import { useCallback, useContext } from 'react';

import { DrawerContext } from './DrawerContext';
import { LayerContext } from './LayerContext';
import type { DrawerConfirmationOptions } from './layerStoreReducer';

export const useDrawer = () => {
    const { store, busyLayerIds, push, pop, requestClose, confirm } = useContext(DrawerContext);
    const { id, isTopLayer } = useContext(LayerContext);
    const requestLayerClose = useCallback(
        (onClose?: () => void) => {
            if (id === undefined && onClose) {
                onClose();
                return;
            }
            requestClose(id, onClose);
        },
        [id, requestClose]
    );
    const confirmLayerAction = useCallback((options: DrawerConfirmationOptions) => confirm(options, id), [confirm, id]);

    return {
        layers: store.layers,
        hasLayers: store.layers.length > 0,
        isTopLayer,
        isBusy: id !== undefined && busyLayerIds.has(id),
        push,
        layerId: id,
        pop,
        requestClose: requestLayerClose,
        confirm: confirmLayerAction,
    };
};
